import { Map } from 'immutable';

import {
  setDrawingType,
} from './StructureFilterConstants';

export const initialState = Map({

});

export function structureFilterReducer (state = initialState, action) {
  switch (action.type) {

    case setDrawingType: {
      const { key, data } = action.payload;

      return state.set(key, data);
    }

    default: {
      return state;
    }
  }
}
